import React from 'react';
import { orange_1200, yellow_300 } from '@fiverr-private/sass/helpers';
import { translate } from '@fiverr-private/i18n-react';
import Badge from '../Badge';
import { BadgeProps } from '../../types';
import SellerLevelDiamondIcon from '../SellerLevelDiamondIcon';

import styles from './index.module.scss';

const TopRatedBadge = ({
  showTooltip = true,
  tooltipPosition = 'top',
  dataTestId,
  appendTooltipToBody,
  disableTooltipFlip,
}: BadgeProps) => (
  <Badge
    showTooltip={showTooltip}
    color={orange_1200}
    backgroundColor={yellow_300}
    tooltipContent={translate('badges.top_rated_seller_badge.tooltip')}
    tooltipPosition={tooltipPosition}
    dataTestId={dataTestId}
    appendTooltipToBody={appendTooltipToBody}
    disableTooltipFlip={disableTooltipFlip}
  >
    <div className={styles.wrapper}>
      <p>Top Rated</p>
      <div className={styles.iconsContainer}>
        <SellerLevelDiamondIcon />
        <SellerLevelDiamondIcon />
        <SellerLevelDiamondIcon />
      </div>
    </div>
  </Badge>
);

TopRatedBadge.displayName = 'TopRatedBadge';

export default TopRatedBadge;
